import { Card } from "@/core/components/ui/card/card";
import { Stack } from "@/core/components/ui/stack/stack";
import { Typography } from "@/core/components/ui/typography/typography";
import { useGetBusinessStats } from "@/business/query";
import { formatPhoneNumber } from "@/core/utils/phone";
import { useGetMyUserWithBusiness } from "@/user/query";
import PostOnboardingItems from "@/waiting-pages/post-onboarding/post-onboarding-items";
import { AdvocateAndReferralCounters } from "./referral-stats/advocate-and-referral-counters";

export const NoReferrals = () => {
  const { data: userWithBusiness } = useGetMyUserWithBusiness();
  const { data: businessStats } = useGetBusinessStats(
    userWithBusiness?.business?.id,
  );

  if (!userWithBusiness) return null;
  const { business } = userWithBusiness;

  return (
    <Stack className="mt-20" align="center" gap="none" fullWidth>
      <Stack justify="center" align="center">
        <Typography variant="subtitleW1" textColor="tertiary">
          Let customers know to text REFERRAL to
        </Typography>
        <Typography variant="statNumber" textColor="interactive">
          {formatPhoneNumber(business?.phone_number)}
        </Typography>
      </Stack>
      <Card className="mt-10 w-[710px] p-6">
        <AdvocateAndReferralCounters
          advocates={businessStats?.program_signup_count}
          referrals={businessStats?.referral_count}
        />
      </Card>
      <PostOnboardingItems className="mt-10" />
    </Stack>
  );
};
